module.exports = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  CollectSuccess: 'Collect success',
  MerchantStoreSuccess: 'Store success',
  CustomerStoreSuccess: 'Return success',
  ReturnSuccess: 'Return success',
  Success: 'Success',
  Exp: 'Exp.',
  UnStored: 'Unstored',
  Stored: 'Stored',
  ExpiredReturned: 'Expired returned',
  Returns: 'Returns',
  Returned: 'Returned',
  Arriving: 'Arriving',
  Collected: 'Collected',
  Created: 'Created',
  Cancelled: 'Cancelled',
  Store: 'Store',
  Collect: 'Collect',
  common: {
    Back: 'Back',
    Back2: 'Back',
    locationName: '',
    Home: 'Home',
    Save: 'Save',
    Confirm: 'Confirm',
    ScanNext: 'Scan next',
    Cancel: 'Cancel',
    reScan: 'ReScan',
    ScanBarcode: 'Scan barcode',
    ScanToStore: 'Scan to store',
    ScanToReturn: 'Scan to return',
    monthArr: new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Spt', 'Oct', 'Nov', 'Dec'),
    weekArr: new Array('Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'),
    dayFormat: '',
    space: ' ',
    loadMore: 'Load more...',
    finishLoading: 'Loading completed',
    noMore: 'No more items'
  },
  login: {
    LoginTitle: 'Access LoggiPonto',
    Login: 'Login',
    Username: 'Username',
    Password: 'Password'
  },
  bottom: {
    line: 'CS Hotline: ',
    support: 'Click here to support'
  },
  index: {
    profile: 'My profile',
    locationName: '',
    Arriving: 'Arriving',
    Stored: 'Stored',
    Collected: 'Collected',
    Returns: 'Returns',
    Store: 'Store',
    Collect: 'Collect',
    Courier: 'Return to courier',
    expired: 'Return expired',
    OrderId: 'Order ID, ',
    PhoneNumber: 'phone number, ',
    NewLabelNumber: 'new label number'
  },
  profile: {
    TodayLogs: 'Today logs',
    Total: 'Total',
    ThisMonth: 'This month',
    LocationID: 'Location ID',
    LocationName: 'Location name ',
    Address: 'Address',
    ShopContact: 'Shop contact',
    Username: 'Username',
    RegisteredPhoneNumber: 'Registered phone number',
    BusinessHours: 'Business hours',
    Edit: 'Edit',
    Logout: 'Logout',
    Parcels: 'Parcels',
    withLabel: 'with label',
    withoutLabel: 'without label'
  },
  editProfile: {
    EditProfile: 'Edit profile',
    LocationID: 'Location ID',
    LocationNameEnglish: 'Location name (English)',
    LocationNameChinese: 'Location name (Chinese)',
    AddressEnglish: 'Address (English)',
    AddressChinese: 'Address (Chinese)',
    Username: 'Username',
    RegisteredPhoneNnumber: 'Registered phone number',
    BusinessHours: 'Business hours',
    ShopContact: 'Shop contact',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    Rest: 'Rest',
    AddMoreHours: 'Add more hours',
    OpenHours: '24 hours',
    ExceptionsOrHolidays: 'Exceptions or holidays',
    AddSpecialHours: 'Add or remove special hours',
    Open: 'Open',
    Close: 'Close',
    SelectSpecialDays: 'Select special days',
    OK: 'OK',
    Cancel: 'Cancel'
  },
  selectCompany: {
    ReturnCourier: 'Return to courier',
    ReturnExpired: 'Return expired'
  },
  editRemark: {},
  expired: {
    Returns: 'Returns',
    Expired: 'Expired'
  },
  barCode: {
    PleaseAim: 'Please aim at the barcode',
    PleaseAimBarcode: 'Please aim at the mini-label’s barcode',
    PleaseAimWithLabel: 'Please aim at the barcode\nor QR code on the package',
    PleaseAimWithoutLabel1: 'Please aim at the barcode\n or QR code on the customer\'s\n phone',
    PleaseAimWithoutLabel2: 'Please aim at the <strong><u>new barcode</u></strong>',
    manually: 'Enter barcode manually',
    manuallyWITHOUT_LABEL: 'Enter barcode manually',
    manuallyWithoutLabelStep2: 'Enter the mini label code',
    Loading: 'Loading...',
    mismatch: 'This parcel does not match the PIN code',
    formatnomatch: 'The barcode invalid. Please scan again or enter it manally',
    noPermission: 'No permission to access camera!',
    nofind: 'Cannot find camera!',
    confirmMiniLabelText: 'Please check the scanned content:',
    withoutLabelStep1Text: 'Search for parcel',
    withoutLabelStep2Text: 'Attach label',
    ScanMessageWithoutLabelStep1Text: 'Scan the customer’s \nQR code',
    ScanMessageWithoutLabelStep2Text: 'Scan the mini label’s \nQR code'
  },
  qrCode: {
    PleaseAim: 'Please aim at the QR code',
    manually: 'Enter qrcode manually'
  },
  enterBarCode: {
    EnterBarcode: 'Enter barcode',
    EnterBarcodeWITHOUT_LABEL: 'Enter the new barcode \n number',
    EnterBarcodeStore: 'Enter the new barcode \n number',
    EnterName: 'Enter customer name',
    EnterID: 'Enter national ID number'
  },
  enterPIN: {
    EnterPIN: 'Enter PIN code',
    ScanApp: 'Scan App QR'
  },
  success: {
    Note: 'Notes (Optional): e.g. Parcel location',
    ScanParcel: 'Scan parcel location',
    EditNote: 'Edit notes',
    CollectSuccess: 'Collect success',
    StoreSuccess: 'Store success',
    ReturnSuccess: 'Return success',
    Success: 'Success',
    successID: 'Order ID',
    step1SuccessTitle: 'Accepted',
    step1SuccessMsg: 'Get ready to scan the\nnew label’s barcode',
    step1ScanNext: 'Scan new barcode',
    newOrderNumber: 'New order number',
    withoutLabelStep2SuccessTitle: 'Parcel found',
    withoutLabelStep2SuccessTitle2: 'Stick the mini label \non the parcel and \nscan the code',
    step1ScanNextWithoutLabel: 'Scan the mini label'
  },
  details: {
    OrderDetails: 'Order details',
    OrderID: 'Order ID',
    NewLabelNumber: 'New label number',
    Logistics: 'Logistics',
    Recipient: 'Recipient',
    TimeStored: 'Time stored',
    Notes: 'Notes',
    Edit: 'Edit',
    ScanBarcode: 'Scan barcode',
    ScanToStore: 'Scan to store',
    ScanToReturn: 'Scan to return',
    TimeCollected: 'Time collected',
    EditNotes: 'Edit notes',
    ScanParcel: 'Scan parcel location'
  },
  total: {
    Total: 'Total',
    Completed: 'Completed',
    InProgress: 'In progress'
  },
  todayLogs: {
    TodayLogs: 'Today logs'
  },
  month: {
    TimeStored: 'Time stored',
    TimeCollected: 'Time collected'
  },
  thisMonth: {
    ThisMonth: 'This month'
  },
  searchResult: {
    CannotFind: 'Cannot find the order',
    TimeStored: 'Time stored',
    TimeCollected: 'Time collected',
    TimeReturned: 'Time returned',
    TimeRecreated: 'Time recreated',
    Recreated: 'Time recreated'
  },
  selectFlow: {
    Title: 'What type of item\ndo you want to\nreceive?',
    WithLabelTitle: 'Package with label',
    WithLabelSubTitle: 'Parcel with label printed by the customer',
    WithoutLabelTitle: 'Package without label',
    WithoutLabelSubTitle: 'The customer shows the QR code or tracking \nnumber received via the app or email'
  },
  labeledPackage: {
    returnSuccess: 'Return success，order number：{{orderId}}'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js